import { render, staticRenderFns } from "./AddUserToFolder.vue?vue&type=template&id=6edb3c2b&scoped=true&lang=true&"
import script from "./AddUserToFolder.vue?vue&type=script&lang=js&"
export * from "./AddUserToFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb3c2b",
  null
  
)

export default component.exports